import { CartsEffects } from './carts.effect';
import { CollectionsEffects } from './collections.effect';
import { PagesEffects } from './pages.effect';
import { ProductsEffects } from './products.effect';
import { MenuEffects } from './menu.effect';
import { CustomerEffects } from './customer.effect';
import { OrdersEffects } from './orders.effect';
import { AddressesEffects } from './addresses.effect';
import { ShopEffects } from './shop.effect';
import { SearchEffects } from './search.effect';
import { TaxExemptionsEffects } from './tax-exemptions.effect';
import { KlaviyoEffects } from './klaviyo.effect';

export const effects = [
  ProductsEffects,
  CollectionsEffects,
  CartsEffects,
  MenuEffects,
  PagesEffects,
  CustomerEffects,
  OrdersEffects,
  AddressesEffects,
  ShopEffects,
  SearchEffects,
  TaxExemptionsEffects,
  KlaviyoEffects,
];

export * from './products.effect';
export * from './collections.effect';
export * from './carts.effect';
export * from './menu.effect';
export * from './pages.effect';
export * from './customer.effect';
export * from './orders.effect';
export * from './addresses.effect';
export * from './shop.effect';
export * from './search.effect';
export * from './tax-exemptions.effect';
export * from './klaviyo.effect';
